// The applicant's invite-link token (the `?token=` query value) is their session: every
// applicant API call sends it as the raw `Authorization` header (see services/api.ts).
//
// The URL stays the source of truth — pages carry `?token=` between steps — and the
// verification container copies it here on every render. Services have no router context, so
// they read it from here.
//
// Memory only, on purpose. Every page that makes applicant calls sits under the verification
// container, which sets this during render, so nothing needs a fallback. A sessionStorage copy
// was tried and dropped: storage is shared by every document in the tab, so after
// setApplicantToken(null) the getter could still hand back another document's token, and it
// left a raw session credential sitting in storage.
let current: string | null = null;

/** The token in a location's query string, or null when it is absent or blank. */
export const tokenFromSearch = (search: string): string | null => {
  const token = new URLSearchParams(search).get('token');
  return token && token.trim() ? token : null;
};

export const setApplicantToken = (token: string | null): void => {
  current = token;
};

export const getApplicantToken = (): string | null => current;
